jQuery(document).ready(function () {
  $('.variant-description-wrapper').eq(0).show();

  if (jQuery("free-shipping-bar.shipping-bar").css("--progress") == "1") {
    jQuery("span.shipping-bar__progress").css("border-color", "#45ba13");
    jQuery("free-shipping-bar.shipping-bar .shipping-bar__progress").addClass(
      "bar_custom"
    );
  } else {
    jQuery(
      "free-shipping-bar.shipping-bar .shipping-bar__progress"
    ).removeClass("bar_custom");
  }



    $('#fixed-bar-cart select').change(function() {
      var value = this.value;
      var optionName = $(this).find(':selected').attr('name');
      var valueSelected = $(this).find(':selected').val();
      console.log('optionName---'+optionName+'---valueSelected = '+valueSelected);
      jQuery('.variant-wrapper.js fieldset[name="'+optionName+'"] input[value="'+valueSelected+'"]').click();
       updateFixedBar();
    });

    jQuery('.variant-input-wrap .variant-input :radio').change(function() {
       var ValSelected = $(this).val();
       var OpName = $(this).attr('name');
       $('#fixed-bar-cart select[name="'+OpName+'"]').val(ValSelected).change();
      
    });

  

    $("#fixed-bar-cart #fixed-bar-add").click(function(){
      $('.product-single__meta button.add-to-cart').trigger('click');
    });


  
});

var updateFixedBar = function() {
  var productPrice = jQuery('.product-single__meta .product-block--price').html();
  var buttonText = jQuery('.product-single__meta button.add-to-cart').html();
  jQuery('#fixed-bar-cart #fixed-bar-price').html(productPrice);
  jQuery('#fixed-bar-cart #fixed-bar-add').html(buttonText);
}


jQuery(window).load(function () {
  if (jQuery("free-shipping-bar.shipping-bar").css("--progress") == "1") {
    jQuery("span.shipping-bar__progress").css("border-color", "#45ba13");
    jQuery("free-shipping-bar.shipping-bar .shipping-bar__progress").addClass(
      "bar_custom"
    );
  } else {
    jQuery(
      "free-shipping-bar.shipping-bar .shipping-bar__progress"
    ).removeClass("bar_custom");
  }


   updateFixedBar();
  
});

  jQuery(document).on("click", '.cart__remove a', function(e) {
    e.preventDefault();
    jQuery(this).closest('.cart__item-sub').find('.js-qty__num').val('0');

    var variant_id = jQuery(this).attr('data-id');
     console.log(variant_id);
    var obj = {};
    obj[variant_id]= 0;
    removem_data = { updates: obj };
    jQuery.ajax({
        url: "/cart/update.js",
        type: "POST",
        data: JSON.stringify(removem_data), 
        contentType: "application/json",
        dataType: 'json',
        success: function(responce) {
          // console.log('removed');
		  //$('.cart__item[data-id="'+variant_id+'"]').remove();
          document.dispatchEvent(new CustomEvent('cart:updated'));
          document.dispatchEvent(new CustomEvent('cart:build'));

        }            
      });
  }); 


$(window).scroll(function() {

  var fixedBar = $('#product_block_buyBtn');
  if (fixedBar.length) {

    if ($(this).scrollTop() < $('#product_block_buyBtn').offset().top) {
    	$('#fixed-bar-cart').removeClass('active');
	}

	if ($(this).scrollTop() >= $('#product_block_buyBtn').offset().top) {
    	$('#fixed-bar-cart').addClass('active');
	}
  }
	

});


var position = $(window).scrollTop(); 
$(window).scroll(function() {
    var scroll = $(window).scrollTop();
    if(scroll > position) {
        $('#SiteHeader').addClass('scrolling-down').removeClass('scrolling-up');
        $('.announcement-bar').addClass('scrolling-down').removeClass('scrolling-up');
    } else {
        $('#SiteHeader').removeClass('scrolling-down').addClass('scrolling-up');
        $('.announcement-bar').removeClass('scrolling-down').addClass('scrolling-up');
    }
    if(scroll > 250){
      $('.announcement-bar').addClass('sticky');
    }else{
      $('.announcement-bar').removeClass('sticky');
    }
    position = scroll;
});


document.addEventListener('variant:change', function(evt) {
  console.log(evt.detail.variant);
  var variant = evt.detail.variant;
  // Update variant description
  if($('.variant-description-wrapper').length > 0){
    $('.variant-description-wrapper .variant-description').hide();
    $('.variant-description-wrapper .variant-description.variant-description-'+variant.id).show();
    var variant_title = $('.variant-description-wrapper .variant-title.variant-title-'+variant.id).val();
    if(variant_title != ''){
      $('h1.product-single__title').text(variant_title);
    }
  }

  // Update product content for snijplank
  $('.product-content-snijplank').removeClass('active');
  if(variant.title.indexOf("Acacia") != -1 && variant.title.indexOf("Set") != -1){
    $('.product-content-acacia-set').addClass('active');
  }else if (variant.title.indexOf("Acacia") != -1  && variant.title.indexOf("XL") != -1){
    $('.product-content-acacia-xl').addClass('active');
  }else if (variant.title.indexOf("Acacia") != -1  && variant.title.indexOf("L") != -1){
    $('.product-content-acacia-l').addClass('active');
  }else if (variant.title.indexOf("Acacia") != -1  && variant.title.indexOf("M") != -1){
    $('.product-content-acacia-m').addClass('active');
  }else if (variant.title.indexOf("Bamboe") != -1 && variant.title.indexOf("Set") != -1){
    $('.product-content-bamboe-set').addClass('active');
  }else if (variant.title.indexOf("Bamboe") != -1){
    $('.product-content-bamboe-m').addClass('active');
  }

  // Update product link snijplank
  var urlRedirect = $('.snijplank-product-'+variant.id).val();
  if(urlRedirect){
    $('#snijplank-link').attr('href',urlRedirect);
  }

  // Update product content for hakblok
  $('.product-content-hakblok').removeClass('active');
  if(variant.title.indexOf("Acacia") != -1 && variant.title.indexOf("Classic") != -1){
    $('.product-content-acacia-classic').addClass('active');
  }else if (variant.title.indexOf("Acacia") != -1  && variant.title.indexOf("Sharp") != -1){
    $('.product-content-acacia-sharp').addClass('active');
  }else if (variant.title.indexOf("Bamboe") != -1  && variant.title.indexOf("Classic") != -1){
    $('.product-content-bamboe-classic').addClass('active');
  }else if (variant.title.indexOf("Bamboe") != -1  && variant.title.indexOf("Sharp") != -1){
    $('.product-content-bamboe-sharp').addClass('active');
  }

  // Update product link hakblok
  var urlRedirect = $('.hakblok-product-'+variant.id).val();
  if(urlRedirect){
    $('#hakblok-link').attr('href',urlRedirect);
  }

  // Handle custom id for product listings snijplank/hakblok
  var customId = $('.variant-item-'+variant.id).data('id');
  $('#custom-id').val(customId);
  var customAvailable = $('.variant-item-'+variant.id).data('available');
  if(customAvailable){
    var customBtnText = $('.variant-item-'+variant.id).data('atc-text');
    $('.custom-atc').text(customBtnText).removeAttr('disabled');
  }else{
    var customBtnText = $('.variant-item-'+variant.id).data('soldout-text');
    $('.custom-atc').text(customBtnText).attr('disabled','disabled');
  }
  
});

function productATC(){
  document.querySelector('a.custom-atc').classList.add('btn--loading');
  const variantID = document.querySelector('#custom-id').value;
  console.log(variantID);
  let formData = {
  'items': [{
    'id': variantID,
    'quantity': 1
    }]
  };

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    //return response.json();
    document.querySelector('a.custom-atc').classList.remove('btn--loading');
    document.dispatchEvent(new CustomEvent('cart:build'));
    setTimeout(function() {
      document.querySelector('.js-drawer-open-cart').click();
    }, 700);
    
  })
  .catch((error) => {
    console.error('Error:', error);
  });
    
}

// Select all links with hashes
$('a[href*="#"]')
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .not('[href="#0"]')
  .click(function(event) {
    // On-page links
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
      && 
      location.hostname == this.hostname
    ) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 1000, function() {
          // Callback after animation
          // Must change focus!
          var $target = $(target);
          $target.focus();
          if ($target.is(":focus")) { // Checking if the target was focused
            return false;
          } else {
            $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
            $target.focus(); // Set focus again
          };
        });
      }
    }
  });